<div>
  <div class="policies-comment" [class.fix-collapse]="showHowTo" *ngIf="!removeHowTo">
    <app-auto-detail-howto [show]="showHowTo" [provider]="provider"></app-auto-detail-howto>
  </div>
  <div class="policies-comment"  [class.fix-collapse]="showComments" *ngIf="content">
    <div class="policies-comment-cont">
      <div class="comment">
        <div class="auto-header" (click)="toggleComments()">
          <div class="header-title policies-cancelation">
            <h4>{{ 'AUTOS_MODULE.BOOKING.POLICIES_CANCELATION_TITLE' | transloco }}</h4>
          </div>
          <div class="icon-cont" [class.rotate-180]="showComments"><i aria-hidden="true" class="icon-expand"></i></div>
        </div>
        <div class="policies-body" [class.collapse]="showComments">
          <ng-container>
            <ul class="auto-policies">
              <li [innerHTML]="content"></li>
            </ul>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
